import BaseIncomingPayload from "./base-incoming-payload.ts";
import IncomingPayloadEvent from "../../enums/incoming-payload-event.ts";
import ParseUtils from "../../utils/parse-utils.ts";

export default class V1GroupRestaurantCategoriesChosen extends BaseIncomingPayload {
  public readonly payload: V1GroupRestaurantCategoriesChosenPayload;

  constructor(payload: Record<string, unknown>) {
    super(payload, IncomingPayloadEvent.V1_GROUP_RESTAURANT_CATEGORIES_CHOSEN);

    this.payload = new V1GroupRestaurantCategoriesChosenPayload(ParseUtils.parseObject(payload, "payload"));
  }
}

export class V1GroupRestaurantCategoriesChosenPayload {
  public readonly group_id: string;
  public readonly user_id: string;

  constructor(payload: Record<string, unknown>) {
    this.group_id = ParseUtils.parseString(payload, "group_id");
    this.user_id = ParseUtils.parseString(payload, "user_id");
  }
}
